module.exports = __webpack_public_path__ + "static/media/need-baby.547eec17.jpg";